module.exports = __webpack_public_path__ + "static/media/payment_icon.fe55b7ed.svg";